<template lang="html">
  <div class="ui-choose-wrapper">
    <div
      class="ui-star-choose"
      :class="{ chooseHover: show === 0, 'title-hide': !showTitle }"
    >
      <ul class="ui-star-choose-select">
        <li
          class="ui-star-choose-select-item"
          :class="{ hover: isAll }"
          @click="selectAll()"
        >
          全部
        </li>
        <li
          class="ui-star-choose-select-item"
          v-for="(item, index) in starLevels"
          :class="{ hover: item.selected }"
          @click="getAll(item, index, $event)"
        >
          <star
            size="big"
            :score="item.starLevel * 30"
            :scoreNo="item.starLevel"
            :levelName="item.starLevelName"
            :needBracket="false"
          ></star>
        </li>
      </ul>
    </div>
    <div class="ui-button">
      <button class="ui-reset-select" @click="reset">重置</button
      ><button class="ui-comfrim-select" @click="submit">确定</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import star from '@/components/common/star'

export default {
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    needRestBt: {
      type: Boolean,
      default: false
    }
  },
  components: {
    star
  },
  data() {
    return {
      api: '',
      show: 0,
      starLevels: [],
      isAll: false
    }
  },
  watch: {
    isActionSheetShow(val) {
      // console.log(val)
      if (val) {
        console.log(this.starLevels)
        if (this.starLevels && this.starLevels.length > 0) {
          this.init()
        }
      }
    }
  },
  computed: {
    ...mapState(['filterLevel', 'starLevelsList', 'isActionSheetShow'])
  },
  methods: {
    ...mapMutations(['setFilterLevel', 'hideActionSheet']),
    toggle(index) {
      this.show = index
    },
    getAll(item, index, $e) {
      item.selected = !item.selected
      if (!item.selected) {
        this.isAll = false
      }
      this.$set(this.starLevels, index, item)
      const selected = this.starLevels.filter(s => s.selected)
      if (selected.length === this.starLevels.length) {
        this.isAll = true
      }
    },
    selectAll() {
      this.isAll = !this.isAll
      this.starLevels.forEach((level, index) => {
        level.selected = this.isAll
        this.$set(this.starLevels, index, level)
      })
    },
    reset() {
      this.starLevels.forEach((level, index) => {
        level.selected = false
        this.$set(this.starLevels, index, level)
      })
      this.isAll = false
    },
    submit() {
      const selectedList = this.starLevels.filter(v => v.selected)
      this.setFilterLevel(selectedList)
      this.hideActionSheet(false)
    },
    init() {
      this.isAll = false
      this.starLevels = [...this.starLevelsList]
      this.starLevels.forEach(o => {
        o.selected = false
        if (this.filterLevel.includes(o)) {
          o.selected = true
        }
      })
      if (
        this.starLevels.length === this.filterLevel.length &&
        this.filterLevel.length > 0
      ) {
        this.isAll = true
      }
    }
  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss">
@import '../../../assets/css/mixin';
.ui-star-choose {
  .ui-star-choose-select-item {
    p {
      font-size: rem(30px);
      color: #121212;
    }
    .star-wrapper {
      .big {
        margin-right: rem(10px);
      }
      li {
        margin-right: 0;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import '../../../assets/css/mixin';
.ui-choose-wrapper {
  position: relative;
  height: 100%;
}
.ui-star-choose {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #fff;
  -webkit-overflow-scrolling: touch;
  display: none;

  .ui-star-choose-select {
    margin-top: rem(10px);
    margin-bottom: rem(10px);
    font-size: 0;
    .ui-star-choose-select-item {
      margin-left: rem(25px);
      font-size: rem(30px);
      height: rem(80px);
      position: relative;
      width: 3.3rem;
      display: inline-flex;
      align-items: center;

      &.hover {
        color: #ff397e;

        &:before {
          font-family: iconfont !important;
          font-size: 28px;
          line-height: 45px;
          font-style: normal;
          -webkit-font-smoothing: antialiased;
          -webkit-text-stroke-width: 0.2px;
          display: block;
          // color: rgba(0,0,0,.5);
          color: #ff397e;
          content: '\e6e1';
          position: absolute;
          right: 15px;
          top: 50%;
          margin-top: -22px;
          margin-right: -10px;
        }
      }
    }

    .selected:after {
      font-family: iconfont !important;
      font-size: 16px;
      line-height: 45px;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
      -webkit-text-stroke-width: 0.2px;
      display: block;
      // color: rgba(0,0,0,.5);
      color: #ff397e;
      content: '\e6e1';
      position: absolute;
      right: 15px;
      top: 50%;
      margin-top: -22px;
      margin-right: -10px;
    }
  }

  &.chooseHover {
    display: block;
  }
  &.title-hide {
    top: 0;
  }
}
.ui-star-choose-group {
  display: flex;
  font-size: rem(30px);
  line-height: rem(80px);
  text-align: center;
  .ui-star-choose-group-item {
    @include border(bottom);
    flex: 1;
    &.hover {
      color: #ff397e;
      &::before {
        border-bottom: 1px solid #ff397e;
      }
    }
  }
}
.ui-button {
  position: absolute;
  bottom: -0.5px;
  left: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: rem(100px);
  text-align: center;
  z-index: 99;
}
.ui-reset-select {
  background-color: #fff;
  color: #121212;
  width: 100%;
  height: rem(100px);
  // display: inline-block;
  line-height: rem(100px);
  font-size: rem(32px);
  border-top: 1px solid #ebebeb;

  // @include border(top);
}
.ui-comfrim-select {
  background-color: #ff6ea2;
  width: 100%;
  color: #fff;
  // display: inline-block;
  height: rem(100px);
  font-size: rem(32px);
}
</style>
